var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCareer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 35"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M13.667 33.333h10.666c5.36 0 6.32-2.146 6.6-4.76l1-10.666c.36-3.254-.573-5.907-6.266-5.907H12.333c-5.693 0-6.626 2.653-6.266 5.907l1 10.666c.28 2.614 1.24 4.76 6.6 4.76M13.666 12v-1.066c0-2.36 0-4.267 4.267-4.267h2.133c4.267 0 4.267 1.907 4.267 4.267V12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M21.667 21.333v1.36c0 1.454-.013 2.64-2.666 2.64-2.64 0-2.667-1.173-2.667-2.626v-1.374c0-1.333 0-1.333 1.333-1.333h2.667c1.333 0 1.333 0 1.333 1.333"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M31.866 18.667a22 22 0 0 1-10.2 4.027M6.494 19.027c3 2.053 6.387 3.293 9.84 3.68"
})));
export default SvgCareer;